export default __webpack_public_path__ + "static/media/Dialog2.f915c5a9.svg";